import React, { useState, useEffect, useMemo } from 'react';
import { db, paths } from '../../firebase/config';
import { collection, getDocs, doc, getDoc, onSnapshot, query, where } from 'firebase/firestore';
import { 
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, Label 
} from 'recharts';

// --- ÍCONES GERAIS ---
const FilterIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>;
const UsersIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const AlertIcon = (props) => <svg {...props} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>;
const CheckCircleIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const MapPinIcon = (props) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const CopyIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>;
const SchoolIcon = (props) => <svg {...props} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>;
const ReportIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>;
const ClockIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>;

// --- ÍCONES PARA O MENU MOBILE INFERIOR ---
const CalendarNavIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>;
const BuildingNavIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><path d="M9 22v-4h6v4"></path><path d="M8 6h.01"></path><path d="M16 6h.01"></path><path d="M12 6h.01"></path><path d="M12 10h.01"></path><path d="M12 14h.01"></path><path d="M16 10h.01"></path><path d="M16 14h.01"></path><path d="M8 10h.01"></path><path d="M8 14h.01"></path></svg>;
const TagNavIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>;
const LayersNavIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 17 22 12"></polyline></svg>;

// --- CORES DO TEMA ---
const COLORS = { primary: '#3182ce', success: '#38a169', warning: '#dd6b20', danger: '#e53e3e', purple: '#805ad5', gray: '#718096' };
const PIE_COLORS = [ '#3182ce', '#38a169', '#805ad5', '#e53e3e', '#dd6b20', '#319795', '#d69e2e', '#4299E1', '#48BB78', '#9F7AEA', '#F56565', '#ED8936', '#38B2AC', '#ECC94B', '#2B6CB0', '#2F855A', '#6B46C1', '#C53030', '#C05621', '#2C7A7B', '#B7791F', '#90CDF4', '#9AE6B4', '#D6BCFA', '#FEB2B2', '#FBD38D', '#81E6D9', '#FAF089' ];

// --- ESTILOS INTERATIVOS TELA ---
const interactiveStyles = `
  .interactive-card { transition: transform 0.2s ease, box-shadow 0.2s ease; }
  .interactive-card:hover { transform: translateY(-2px); box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06) !important; }
  .table-row-hover { transition: background-color 0.1s; }
  .table-row-hover:hover { background-color: #f7fafc !important; }
  .filter-btn { transition: all 0.2s ease; }
  .filter-btn:hover:not(.active) { background-color: #edf2f7 !important; }
  .main-content { padding: 16px; padding-bottom: 24px; }
  .kpi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin-bottom: 16px; }
  .charts-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px; margin-bottom: 16px; align-items: start; }
  .desktop-filters { display: flex; gap: 12px; flex-wrap: wrap; align-items: center; }
  .mobile-bottom-nav { display: none; }
  .resumo-card { flex: 0 0 17%; min-width: 230px; max-width: 250px; background-color: #ffffff; padding: 16px; border-radius: 10px; border: 1px solid #e2e8f0; align-self: flex-start; }
  .custom-legend-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px 8px; list-style: none; padding: 16px 0 0 0; margin: 0; font-size: 10px; font-weight: 700; color: #4a5568; width: 100%; }

  @media (max-width: 768px) {
    .main-content { padding: 12px; padding-bottom: 90px; } 
    .desktop-filters { display: none !important; }
    .resumo-card { flex: 1 1 100% !important; min-width: 100% !important; max-width: 100% !important; margin-bottom: 16px; box-sizing: border-box; }
    .mobile-bottom-nav { display: flex; position: fixed; bottom: 0; left: 0; right: 0; height: 64px; background: #ffffff; border-top: 1px solid #e2e8f0; box-shadow: 0 -4px 15px rgba(0,0,0,0.08); z-index: 1000; justify-content: space-around; align-items: center; padding-bottom: env(safe-area-inset-bottom); }
    .mobile-nav-item { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; height: 100%; color: #94a3b8; gap: 4px; transition: color 0.2s ease; cursor: pointer; }
    .mobile-nav-item.active { color: #3182ce; }
    .mobile-nav-item span { font-size: 10px; font-weight: 700; white-space: nowrap; }
    .mobile-nav-input { position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; z-index: 10; display: block; background: transparent; border: none; padding: 0; margin: 0; }
    .kpi-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
    .charts-grid { grid-template-columns: 1fr; gap: 16px; }
    .chart-card { padding: 12px !important; }
    .custom-legend-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); font-size: 9px; }
  }
`;

// --- UTILITÁRIOS ---
const getLocalYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
const getTodayDate = () => getLocalYYYYMMDD(new Date());

const formatDateBR = (date) => {
    if (!date) return '-';
    if (typeof date !== 'string') return String(date); 
    return date.split('-').reverse().join('/');
};

const normalize = (str) => !str ? 'ND' : String(str).toUpperCase().replace(/["']/g, "").replace(/[°ºª]/g, "").replace(/[^A-Z0-9]/g, "").trim();

const formatLaunchDate = (val) => {
    if (!val) return 'N/D';
    const date = val.seconds ? new Date(val.seconds * 1000) : new Date(val);
    if (isNaN(date.getTime())) return 'N/D';
    const day = String(date.getDate()).padStart(2, '0');
    const months = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
    return `${day}${months[date.getMonth()]}${String(date.getFullYear()).slice(-2)} às ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

const thStyle = { textAlign: 'left', padding: '6px 4px', color: '#a0aec0', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #e2e8f0' };

const Badge = ({ children, tipo }) => {
    const isDetalhado = tipo === 'DETALHADO';
    return (
        <span style={{ fontSize: '10px', fontWeight: '800', padding: '2px 6px', borderRadius: '12px', backgroundColor: isDetalhado ? '#fff5f5' : '#ebf8ff', color: isDetalhado ? '#c53030' : '#2b6cb0', border: `1px solid ${isDetalhado ? '#fed7d7' : '#bee3f8'}`, letterSpacing: '0.5px' }}>
            {children}
        </span>
    );
};

// --- CHECAR SE ESTÁ ATIVAMENTE FORA DA AULA ---
const checkIsAtivoForaDaAula = (reg, dataReferenciaStr, listaComplexos = []) => {
    const now = new Date();
    const todayStr = getLocalYYYYMMDD(now);
    let currentHour = now.getHours();
    let currentMinute = now.getMinutes();

    if (dataReferenciaStr < todayStr) { currentHour = 23; currentMinute = 59; } 
    else if (dataReferenciaStr > todayStr) { currentHour = 0; currentMinute = 0; }

    const currentTimeVal = currentHour * 60 + currentMinute;

    if (reg.expiraAs && typeof reg.expiraAs === 'string' && reg.expiraAs.includes(':')) {
        const [expH, expM] = reg.expiraAs.split(':').map(Number);
        const expTimeVal = expH * 60 + expM;
        return currentTimeVal < expTimeVal; 
    }

    if (listaComplexos.includes(reg.destino) && reg.destino !== 'RESTRIÇÃO') {
        return true;
    }

    if (!reg.isForaDaAula) return false;

    const motivo = reg.motivoForaDaAula;
    let expirationTimeVal = 24 * 60; 

    if (motivo === "1º E 2º TEMPOS") expirationTimeVal = 9 * 60 + 45;
    else if (motivo === "3º E 4º TEMPOS") expirationTimeVal = 11 * 60 + 30;
    else if (motivo === "5º E 6º TEMPOS") expirationTimeVal = 14 * 60 + 30;
    else if (motivo === "7º E 8º TEMPOS") expirationTimeVal = 16 * 60 + 30;
    else if (motivo === "9º E 10º TEMPOS") expirationTimeVal = 18 * 60 + 0;
    else if (motivo === "PERIODO MATUTINO") expirationTimeVal = 11 * 60 + 30;
    else if (motivo === "PERIODO VESPERTINO") expirationTimeVal = 18 * 60 + 0;
    else if (motivo === "PERIODO INTEGRAL") expirationTimeVal = 24 * 60;

    return currentTimeVal < expirationTimeVal;
};

// --- REGRA DE VISIBILIDADE ---
const isRecordVisibleByTimeRules = (reg, dataReferenciaStr, listaComplexos = []) => {
    const now = new Date();
    const todayStr = getLocalYYYYMMDD(now);
    let currentHour = now.getHours();
    let currentMinute = now.getMinutes();

    if (dataReferenciaStr < todayStr) { currentHour = 23; currentMinute = 59; } 
    else if (dataReferenciaStr > todayStr) { currentHour = 0; currentMinute = 0; }

    const currentTimeVal = currentHour * 60 + currentMinute;

    if (reg.expiraAs && typeof reg.expiraAs === 'string' && reg.expiraAs.includes(':')) {
        const [expH, expM] = reg.expiraAs.split(':').map(Number);
        const expTimeVal = expH * 60 + expM;
        if (currentTimeVal >= expTimeVal) return false;
        return true; 
    }

    if (listaComplexos.includes(reg.destino)) return true; 

    if (!reg.isForaDaAula) {
        const isMorningBlock = currentTimeVal >= (8 * 60 + 15) && currentTimeVal <= (11 * 60 + 30);
        const isAfternoonBlock = currentTimeVal >= (13 * 60 + 0) && currentTimeVal <= (16 * 60 + 30);
        if (isMorningBlock || isAfternoonBlock) return false;
    } else {
        const motivo = reg.motivoForaDaAula;
        let expirationTimeVal = 24 * 60; 

        if (motivo === "1º E 2º TEMPOS") expirationTimeVal = 9 * 60 + 45;
        else if (motivo === "3º E 4º TEMPOS") expirationTimeVal = 11 * 60 + 30;
        else if (motivo === "5º E 6º TEMPOS") expirationTimeVal = 14 * 60 + 30;
        else if (motivo === "7º E 8º TEMPOS") expirationTimeVal = 16 * 60 + 30;
        else if (motivo === "9º E 10º TEMPOS") expirationTimeVal = 18 * 60 + 0;
        else if (motivo === "PERIODO MATUTINO") expirationTimeVal = 11 * 60 + 30;
        else if (motivo === "PERIODO VESPERTINO") expirationTimeVal = 18 * 60 + 0;
        else if (motivo === "PERIODO INTEGRAL") expirationTimeVal = 24 * 60;

        if (currentTimeVal >= expirationTimeVal) return false;
    }
    return true;
};

// --- COMPONENTE BOTÃO COPIAR ---
const BotaoCopiarCia = ({ cia, configDestinos, dataReferencia }) => {
    const [copiado, setCopiado] = useState(false);
    const handleCopiar = () => {
        let texto = `*${cia.nome}*\n\n`;
        let totalEf = 0, totalAus = 0;
        const pelotoes = Object.values(cia.pelotoes).sort((a,b) => a.nome.localeCompare(b.nome, 'pt-BR', { numeric: true }));
        const isPermitido = (r) => configDestinos?.complexos?.includes(r.destino) || ['HPM - CONSULTA/EXAME', 'HPM - IAS', 'UIS - IAS', 'UIS - MED/DENT PS'].includes(r.destino);

        pelotoes.forEach(p => { totalEf += p.efetivoTotal; totalAus += p.registros.length; });
        texto += `Efetivo Total: ${totalEf} | Presentes: ${totalEf - totalAus} | Ausentes: ${totalAus}\n\n`;

        pelotoes.forEach(pel => {
            const aus = pel.registros.length;
            texto += `*${pel.nome}*\nEf: ${pel.efetivoTotal} | Pr: ${pel.efetivoTotal - aus} | Aus: ${aus}\n`;
            const filtrados = pel.registros.filter(isPermitido);
            
            if (aus === 0) texto += `(Sem alterações)\n\n`;
            else if (filtrados.length === 0) texto += `(Nenhum registro médico ou detalhado)\n\n`;
            else {
                filtrados.forEach(reg => {
                    const mot = reg.qru_motivo || reg.informacoes_complementares || '';
                    const isFora = checkIsAtivoForaDaAula(reg, dataReferencia, configDestinos.complexos);
                    const fora = isFora ? ' [FORA DE AULA]' : '';
                    const end = (reg.qth_endereco || reg.endereco || reg.local) ? ` - Endereço: ${reg.qth_endereco || reg.endereco || reg.local}` : '';
                    texto += `- ${reg.cadeteNome}: ${reg.destino}${mot ? ` - ${mot}` : ''}${end}${fora}\n`;
                });
                texto += `\n`;
            }
        });
        navigator.clipboard.writeText(texto.trim()).then(() => { setCopiado(true); setTimeout(() => setCopiado(false), 2000); });
    };

    return (
        <button onClick={handleCopiar} style={{ backgroundColor: copiado ? '#38a169' : '#e2e8f0', color: copiado ? 'white' : '#4a5568', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', transition: 'all 0.2s ease', outline: 'none' }}>
            <CopyIcon /> {copiado ? 'Copiado!' : 'Resenha'}
        </button>
    );
};

// --- COMPONENTE ACORDEÃO ---
const AccordionPelotao = ({ pel, configDestinos, usersMap, dataReferencia }) => {
    const [isOpen, setIsOpen] = useState(false);
    const totalBaixas = pel.registros.length;
    const totalPresentes = pel.efetivoTotal - totalBaixas;
    const temLideranca = pel.lideranca && (pel.lideranca.chefe || pel.lideranca.subChefe);
    const temConteudo = totalBaixas > 0 || temLideranca;
    
    return (
        <div style={{ marginBottom: '6px', border: '1px solid #e2e8f0', borderRadius: '6px', overflow: 'hidden', backgroundColor: 'white' }}>
            <div onClick={() => temConteudo && setIsOpen(!isOpen)} style={{ padding: '8px 12px', backgroundColor: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: temConteudo ? 'pointer' : 'default', transition: 'background-color 0.2s' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', width: '100%' }}>
                    <span style={{ fontSize: '13px', fontWeight: '700', color: '#2d3748' }}>{pel.nome}</span>
                    <span style={{ fontSize: '11px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span style={{ color: '#2b6cb0', backgroundColor: '#ebf8ff', padding: '2px 6px', borderRadius: '4px' }}>{pel.efetivoTotal} Cadetes</span>
                        <span style={{ color: '#a0aec0' }}>|</span>
                        {totalBaixas > 0 && (
                            <>
                                <span style={{ color: '#dd6b20', backgroundColor: '#fffaf0', padding: '2px 6px', borderRadius: '4px', border: '1px solid #feebc8' }}>{totalBaixas} {totalBaixas === 1 ? 'novidades' : 'novidades'}</span>
                                <span style={{ color: '#a0aec0' }}>|</span>
                            </>
                        )}
                        <span style={{ color: '#38a169', backgroundColor: '#f0fff4', padding: '2px 6px', borderRadius: '4px', border: '1px solid #c6f6d5' }}>
                            {totalBaixas > 0 ? `${totalPresentes} ${totalPresentes === 1 ? 'presente' : 'presentes'}` : 'Todos presentes'}
                        </span>
                    </span>
                </div>
                {temConteudo && <span style={{ fontWeight: 'bold', color: '#4a5568', fontSize: '16px', lineHeight: '1', marginLeft: '12px' }}>{isOpen ? '-' : '+'}</span>}
            </div>

            {isOpen && temConteudo && (
                <div style={{ padding: '8px 12px 12px 12px', backgroundColor: '#fff', borderTop: '1px dashed #edf2f7' }}>
                    {temLideranca && (
                        <div style={{ marginBottom: totalBaixas > 0 ? '12px' : '0', padding: '8px 12px', backgroundColor: '#f8fafc', borderRadius: '6px', border: '1px solid #edf2f7', display:'flex', flexWrap: 'wrap', gap:'16px', fontSize: '12px', color: '#4a5568' }}>
                            {pel.lideranca.chefe && <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><span style={{ fontWeight: '800', color: '#2b6cb0' }}>Chefe:</span> <span style={{ fontWeight: '700', color: '#2d3748' }}>Cad PM {pel.lideranca.chefe}</span></span>}
                            {pel.lideranca.subChefe && <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><span style={{ fontWeight: '800', color: '#718096' }}>Subchefe:</span> <span style={{ fontWeight: '700', color: '#2d3748' }}>Cad PM {pel.lideranca.subChefe}</span></span>}
                        </div>
                    )}

                    {totalBaixas > 0 && (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', minWidth: '400px' }}>
                                <thead><tr><th style={thStyle}>Cadete</th><th style={thStyle}>Destino</th><th style={thStyle}>Motivo / Obs</th><th style={thStyle}>Período</th></tr></thead>
                                <tbody>
                                    {pel.registros.map(reg => {
                                        let nomeLancador = reg.nome_guerra_executor;
                                        if (!nomeLancador || nomeLancador === 'Não identificado') {
                                            nomeLancador = usersMap?.[reg.editadoPor || reg.criadoPor] || 'Não identificado';
                                        }
                                        
                                        const isForaAtivo = checkIsAtivoForaDaAula(reg, dataReferencia, configDestinos.complexos);

                                        return (
                                            <tr key={reg.id} className="table-row-hover" style={{ borderBottom: '1px solid #f1f5f9' }}>
                                                <td style={{ padding: '6px 4px', fontWeight: '600', color: '#2d3748', verticalAlign: 'top', minWidth: '80px' }}>{reg.cadeteNome}</td>
                                                <td style={{ padding: '6px 4px', verticalAlign: 'top', minWidth: '90px' }}><Badge tipo={configDestinos.complexos.includes(reg.destino) ? 'DETALHADO' : 'SIMPLES'}>{reg.destino}</Badge></td>
                                                <td style={{ padding: '6px 4px', color: '#4a5568', verticalAlign: 'top' }}>
                                                    <div style={{ marginBottom: (reg.qth_endereco || reg.endereco || reg.local) ? '4px' : '0' }}>{reg.qru_motivo || reg.informacoes_complementares || '-'}{isForaAtivo && <span style={{color:COLORS.danger, fontWeight:'bold', display:'inline-block', fontSize:'9px', marginLeft: '6px', backgroundColor: '#fff5f5', padding: '2px 4px', borderRadius: '4px'}}>FORA DA SALA</span>}</div>
                                                    {(reg.qth_endereco || reg.endereco || reg.local) && (
                                                        <div style={{ fontSize: '10px', color: '#718096', display: 'flex', alignItems: 'flex-start', gap: '4px' }}><div style={{ marginTop: '1px', flexShrink: 0 }}><MapPinIcon width="10" height="10" /></div><span>{reg.qth_endereco || reg.endereco || reg.local}</span></div>
                                                    )}
                                                    {reg.expiraAs && <div style={{ color: '#dd6b20', fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>[EXPIRA ÀS: {reg.expiraAs}]</div>}
                                                    <div style={{ fontSize: '9px', color: '#94a3b8', marginTop: '4px' }}>Lançado por: {nomeLancador} em: {formatLaunchDate(reg.timestamp)}</div>
                                                </td>
                                                <td style={{ padding: '6px 4px', color: '#718096', verticalAlign: 'top', minWidth: '110px' }}><div style={{ fontWeight: '500', color: '#2d3748' }}>{formatDateBR(reg.periodo_inicio)} - {formatDateBR(reg.periodo_fim)}</div></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const NewDashboard = () => {
  // Separamos o loading estático do dinâmico
  const [loadingStatic, setLoadingStatic] = useState(true);
  const [loadingRegistros, setLoadingRegistros] = useState(true);
  const loading = loadingStatic || loadingRegistros;

  const [isGenerating, setIsGenerating] = useState(false);
  const [dataReferencia, setDataReferencia] = useState(getTodayDate());
  
  const [registros, setRegistros] = useState([]); 

  const [mapaPelotaoCia, setMapaPelotaoCia] = useState({}); 
  const [contagemEfetivo, setContagemEfetivo] = useState({}); 
  const [nomesOriginais, setNomesOriginais] = useState({}); 
  const [configDestinos, setConfigDestinos] = useState({ simples: [], complexos: [] });
  const [liderancaMap, setLiderancaMap] = useState({});
  const [usersMap, setUsersMap] = useState({}); 
  const [usuariosProblematicos, setUsuariosProblematicos] = useState([]);
  
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);

  const [filtroCia, setFiltroCia] = useState('TODAS');
  const [filtroTipo, setFiltroTipo] = useState(() => { return localStorage.getItem('filtroTipo_dashboard') || 'TODOS'; });
  const [filtroDestinoExato, setFiltroDestinoExato] = useState('TODOS'); 
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [timeTicker, setTimeTicker] = useState(0);

  useEffect(() => {
      const timer = setInterval(() => { setTimeTicker(t => t + 1); }, 60000);
      return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => { localStorage.setItem('filtroTipo_dashboard', filtroTipo); }, [filtroTipo]);

  // EFEITO 1: Carregar dados estáticos (Roda APENAS UMA VEZ)
  useEffect(() => {
    let isMounted = true;
    
    const fetchStaticData = async () => {
      try {
        const fetchWithFallback = async (pathsList) => {
            for (const pathArr of pathsList) {
                const snap = await getDocs(collection(db, ...pathArr)).catch(() => ({ empty: true }));
                if (!snap.empty) return snap;
            }
            return { empty: true, forEach: () => {} };
        };

        const configSnap = await getDoc(doc(db, 'artifacts', 'app-estagios', 'public', 'data', 'config_geral', 'destinos_opcoes')).catch(() => ({ exists: () => false }));
        if (!isMounted) return;
        if (configSnap.exists()) setConfigDestinos({ simples: configSnap.data().simples || [], complexos: configSnap.data().complexos || [] });

        const liderancaSnap = await fetchWithFallback([['public', 'data', 'lideranca_pelotoes'], ['artifacts', 'app-estagios', 'public', 'data', 'lideranca_pelotoes'], ['lideranca_pelotoes']]);
        const mapLid = {};
        if (liderancaSnap.forEach) { liderancaSnap.forEach(d => { mapLid[d.id] = d.data(); }); }
        if (!isMounted) return;
        setLiderancaMap(mapLid);

        const companhiasSnap = await fetchWithFallback([['artifacts', 'app-estagios', 'public', 'data', 'companhias'], ['companhias']]);
        const mapCiaIdToName = {};
        if (companhiasSnap.forEach) { companhiasSnap.forEach(doc => { const d = doc.data(); if(d.id) mapCiaIdToName[d.id] = d.nome; mapCiaIdToName[doc.id] = d.nome; }); }

        const pelotoesSnap = await fetchWithFallback([['artifacts', 'app-estagios', 'public', 'data', 'pelotoes'], ['pelotoes']]);
        const mapPelotaoToCia = {}, originaisMap = {}, mapPelotaoIdToNormName = {}; 

        if (pelotoesSnap.forEach) {
            pelotoesSnap.forEach(docSnap => {
                const d = docSnap.data();
                const nomeCia = mapCiaIdToName[d.companhia_id] || d.companhia_nome || d.companhia || 'Sem Cia Definida';
                if (d.nome) {
                    const normName = normalize(d.nome);
                    mapPelotaoToCia[normName] = nomeCia;
                    originaisMap[normName] = d.nome.replace(/["']/g, "").trim(); 
                    mapPelotaoIdToNormName[docSnap.id] = normName;
                    if (d.id) mapPelotaoIdToNormName[d.id] = normName;
                }
            });
        }
        if (!isMounted) return;
        setMapaPelotaoCia(mapPelotaoToCia);

        const usersSnap = await getDocs(collection(db, paths.users)).catch(() => ({ forEach: () => {} })); 
        const countMap = {}, problematicosTemp = {}, tempUsersMap = {}; 
        
        if (usersSnap.forEach) {
            usersSnap.forEach(d => {
                const data = d.data();
                tempUsersMap[d.id] = data.nome_guerra ? `Cad PM ${data.nome_guerra}` : (data.nome ? `Cad PM ${data.nome}` : 'Não identificado');
                const nivelStr = String(data.nivel || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                const isEstudante = ['cadete', 'cadete_academico', 'escalante', 'aspirante', 'aluno', 'asp'].some(termo => nivelStr.includes(termo));
                
                if (isEstudante) {
                    let normName = mapPelotaoIdToNormName[data.pelotao_id] || normalize(data.pelotao_nome || data.pelotao || 'Sem Pelotão');
                    if (!mapPelotaoToCia[normName] && !problematicosTemp[d.id]) problematicosTemp[d.id] = { id: d.id, nome: data.nome || data.nome_completo || 'NOME EM BRANCO', cpf: data.cpf || data.matricula || 'SEM CPF', pelotao: data.pelotao_nome || data.pelotao };
                    if (!countMap[normName]) countMap[normName] = 0;
                    countMap[normName]++;
                    
                    if (!originaisMap[normName] && normName !== 'ND') {
                        const pName = data.pelotao_nome || data.pelotao || '';
                        originaisMap[normName] = pName ? pName.replace(/["']/g, "").trim() : 'Sem Pelotão';
                    }
                }
            });
        }
        if (!isMounted) return;
        setUsersMap(tempUsersMap); 
        setContagemEfetivo(countMap); 
        setNomesOriginais(originaisMap); 
        setUsuariosProblematicos(Object.values(problematicosTemp));

      } catch (error) { 
          console.error("Erro ao carregar dados estáticos:", error); 
      } finally {
          if (isMounted) setLoadingStatic(false);
      }
    };
    
    fetchStaticData();
    return () => { isMounted = false; };
  }, []); 

  // EFEITO 2: Listener do Resultado Online (Depende da Data de Referência para NÃO baixar o banco todo)
  useEffect(() => {
    setLoadingRegistros(true);
    const registrosRef = collection(db, paths.resultado_online);
    
    // A MÁGICA DA OTIMIZAÇÃO: 
    // Pede ao Firebase APENAS os documentos que ainda estão vigentes na data selecionada ou no futuro.
    // O Firebase vai ignorar milhares de registos do passado e devolver apenas os registos válidos e recentes.
    const qRegistros = query(registrosRef, where("periodo_fim", ">=", dataReferencia));
    
    const unsubscribeRegistros = onSnapshot(qRegistros, (snapshot) => {
        const dadosAtualizados = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        
        // O Firebase filtrou periodo_fim >= dataReferencia.
        // Agora o React só precisa cruzar o periodo_inicio para pegar exatamente os ativos nesse dia
        const dadosExatos = dadosAtualizados.filter(reg => reg.periodo_inicio <= dataReferencia);
        
        setRegistros(dadosExatos);
        setUltimaAtualizacao(new Date());
        setLoadingRegistros(false); 
    }, (error) => {
        console.error("Erro no onSnapshot:", error);
        setLoadingRegistros(false);
    });

    return () => {
        unsubscribeRegistros();
    };
  }, [dataReferencia]); // Trocar a data fará uma nova micro-consulta rápida.

  const destinosDisponiveis = useMemo(() => {
      const setDest = new Set(); registros.forEach(r => { if(r.destino) setDest.add(r.destino); });
      return ['TODOS', ...Array.from(setDest).sort()];
  }, [registros]);

  useEffect(() => { if (filtroDestinoExato !== 'TODOS' && !destinosDisponiveis.includes(filtroDestinoExato)) setFiltroDestinoExato('TODOS'); }, [destinosDisponiveis, filtroDestinoExato]);

  const { dadosConsolidados } = useMemo(() => {
    if (loading) return { dadosConsolidados: null };

    const findLidFuzzy = (searchStr) => {
        if (!searchStr) return null;
        const searchClean = searchStr.toUpperCase().replace(/[^A-Z0-9]/g, '');
        for (const [dbKey, data] of Object.entries(liderancaMap)) {
            const dbClean = dbKey.toUpperCase().replace(/[^A-Z0-9]/g, '');
            if (searchClean === dbClean || searchClean.replace(/O/g, '') === dbClean.replace(/O/g, '')) return data;
        }
        return null;
    };

    let allFiltered = registros;
    if (filtroTipo !== 'TODOS') allFiltered = allFiltered.filter(reg => configDestinos.complexos.includes(reg.destino) ? filtroTipo === 'DETALHADO' : filtroTipo === 'SIMPLES');
    if (filtroDestinoExato !== 'TODOS') allFiltered = allFiltered.filter(reg => reg.destino === filtroDestinoExato);

    const mapUnicos = new Map();
    allFiltered.forEach(reg => { if (reg.cadeteNome) mapUnicos.set(reg.cadeteNome, reg); });
    allFiltered = Array.from(mapUnicos.values());

    const vis = [];

    allFiltered.forEach(reg => {
        const normName = normalize(reg.pelotao || 'Sem Pelotão');
        const nomeCia = mapaPelotaoCia[normName] || 'Outras Unidades';
        if (filtroCia !== 'TODAS' && nomeCia !== filtroCia) return;

        if (isRecordVisibleByTimeRules(reg, dataReferencia, configDestinos.complexos)) {
            vis.push(reg);
        }
    });

    const porCia = {}, porDestino = {}, porGremioEquipe = {}, resumoCiaDestino = {}; 
    let totalFora = 0, totalForaAula = 0; 

    vis.forEach(reg => {
        const normName = normalize(reg.pelotao || 'Sem Pelotão');
        const nomeCia = mapaPelotaoCia[normName] || 'Outras Unidades';
        const displayPelotao = nomesOriginais[normName] || (reg.pelotao || 'Sem Pelotão').replace(/["']/g, "").trim();

        if (!porCia[nomeCia]) porCia[nomeCia] = { nome: nomeCia, ausencias: 0, pelotoes: {} };
        if (!porCia[nomeCia].pelotoes[displayPelotao]) porCia[nomeCia].pelotoes[displayPelotao] = { nome: displayPelotao, registros: [], efetivoTotal: contagemEfetivo[normName] || 0, lideranca: findLidFuzzy(displayPelotao) || findLidFuzzy(reg.pelotao) };

        porCia[nomeCia].pelotoes[displayPelotao].registros.push(reg);
        porCia[nomeCia].ausencias++;
        if (!porDestino[reg.destino]) porDestino[reg.destino] = 0;
        porDestino[reg.destino]++;
        totalFora++;
        
        if (checkIsAtivoForaDaAula(reg, dataReferencia, configDestinos.complexos)) {
            totalForaAula++;
        }

        if (!resumoCiaDestino[nomeCia]) resumoCiaDestino[nomeCia] = {};
        const destinoUpper = String(reg.destino || 'NÃO INFORMADO').toUpperCase();
        if (!resumoCiaDestino[nomeCia][destinoUpper]) resumoCiaDestino[nomeCia][destinoUpper] = 0;
        resumoCiaDestino[nomeCia][destinoUpper]++;

        const destGremio = String(reg.destino || '').toUpperCase();
        if (destGremio.includes('GRÊMIO') || destGremio.includes('GREMIO') || destGremio.includes('EQUIPE')) {
            const mot = reg.qru_motivo || reg.informacoes_complementares || 'Não Especificado';
            if (!porGremioEquipe[mot]) porGremioEquipe[mot] = 0;
            porGremioEquipe[mot]++;
        }
    });

    if (filtroTipo === 'TODOS' && filtroDestinoExato === 'TODOS') {
        Object.keys(contagemEfetivo).forEach(normName => {
            const nomeCia = mapaPelotaoCia[normName] || 'Outras Unidades';
            if (filtroCia !== 'TODAS' && nomeCia !== filtroCia) return;
            if (!porCia[nomeCia]) porCia[nomeCia] = { nome: nomeCia, ausencias: 0, pelotoes: {} };
            const displayPelotao = nomesOriginais[normName] || normName;
            if (!porCia[nomeCia].pelotoes[displayPelotao]) porCia[nomeCia].pelotoes[displayPelotao] = { nome: displayPelotao, registros: [], efetivoTotal: contagemEfetivo[normName], lideranca: findLidFuzzy(displayPelotao) || findLidFuzzy(normName) };
        });
    }

    let totalEfetivoGeral = 0;
    Object.keys(contagemEfetivo).forEach(normName => { if (filtroCia === 'TODAS' || (mapaPelotaoCia[normName] || 'Outras Unidades') === filtroCia) totalEfetivoGeral += contagemEfetivo[normName]; });

    return { 
        dadosConsolidados: {
            totalFora, totalForaAula, totalEfetivo: totalEfetivoGeral, totalEmForma: Math.max(0, totalEfetivoGeral - totalFora), porCia, resumoCiaDestino, 
            graficoCia: Object.values(porCia).map(c => ({ name: c.nome, value: c.ausencias })).sort((a, b) => a.name.localeCompare(b.name, 'pt-BR', { numeric: true })), 
            graficoDestino: Object.keys(porDestino).map(k => ({ name: k, value: porDestino[k] })).sort((a,b) => b.value - a.value),
            graficoGremioEquipe: Object.keys(porGremioEquipe).map(k => ({ name: k, value: porGremioEquipe[k] })).sort((a,b) => b.value - a.value) 
        }
    };
  }, [registros, mapaPelotaoCia, contagemEfetivo, nomesOriginais, filtroCia, filtroTipo, filtroDestinoExato, configDestinos, loading, liderancaMap, dataReferencia, timeTicker]);

  const listaCias = useMemo(() => {
      const s = new Set(Object.values(mapaPelotaoCia));
      if(dadosConsolidados) Object.keys(dadosConsolidados.porCia).forEach(c => s.add(c));
      return ['TODAS', ...Array.from(s).sort()];
  }, [mapaPelotaoCia, dadosConsolidados]);

  const getCorCompanhia = (nome) => {
      if (nome.includes('1ª')) return '#d69e2e'; if (nome.includes('2ª')) return '#38a169'; 
      if (nome.includes('3ª')) return '#3182ce'; if (nome.includes('4ª')) return '#e53e3e'; return '#718096'; 
  };

  const handleGerarRelatorioProfissional = () => {
    if (!dadosConsolidados) return;
    setIsGenerating(true);

    let htmlConteudo = '';

    Object.values(dadosConsolidados.porCia).sort((a,b) => a.nome.localeCompare(b.nome)).forEach(cia => {
        htmlConteudo += `<div class="cia-header">${cia.nome}</div>`;

        Object.values(cia.pelotoes).sort((a,b) => a.nome.localeCompare(b.nome, 'pt-BR', { numeric: true })).forEach(pel => {
            const novidades = pel.registros.length;
            const presentes = pel.efetivoTotal - novidades;
            
            htmlConteudo += `
                <div class="pel-header">
                    <span>${pel.nome}</span>
                    <span class="pel-stats">Efetivo: ${pel.efetivoTotal} | Presentes: ${presentes} | Ausentes: <span style="color:${novidades > 0 ? '#c53030' : '#4a5568'}">${novidades}</span></span>
                </div>
            `;

            if (pel.lideranca && (pel.lideranca.chefe || pel.lideranca.subChefe)) {
                htmlConteudo += `<div class="lideranca-box">`;
                if (pel.lideranca.chefe) htmlConteudo += `<span><b>Chefe:</b> Cad PM ${pel.lideranca.chefe}</span>`;
                if (pel.lideranca.subChefe) htmlConteudo += `<span><b>Subchefe:</b> Cad PM ${pel.lideranca.subChefe}</span>`;
                htmlConteudo += `</div>`;
            }

            if (novidades > 0) {
                htmlConteudo += `
                    <table>
                        <thead>
                            <tr>
                                <th style="width: 25%">Cadete</th>
                                <th style="width: 20%">Destino</th>
                                <th style="width: 35%">Motivo / Observações</th>
                                <th style="width: 20%">Período</th>
                            </tr>
                        </thead>
                        <tbody>
                `;
                
                pel.registros.forEach(reg => {
                    const mot = reg.qru_motivo || reg.informacoes_complementares || '-';
                    const endereco = (reg.qth_endereco || reg.endereco || reg.local) ? `<br><span class="endereco">End: ${reg.qth_endereco || reg.endereco || reg.local}</span>` : '';
                    
                    const isFora = checkIsAtivoForaDaAula(reg, dataReferencia, configDestinos.complexos);
                    const fora = isFora ? ' <span class="fora-aula">[FORA DE AULA]</span>' : '';
                    
                    htmlConteudo += `
                        <tr>
                            <td><b>${reg.cadeteNome}</b></td>
                            <td>${reg.destino}</td>
                            <td>${mot}${fora}${endereco}</td>
                            <td>${formatDateBR(reg.periodo_inicio)} a ${formatDateBR(reg.periodo_fim)}</td>
                        </tr>
                    `;
                });

                htmlConteudo += `</tbody></table>`;
            } else {
                htmlConteudo += `<div class="sem-alteracao">Sem alterações. Todos os cadetes presentes.</div>`;
            }
        });
    });

    if (Object.keys(dadosConsolidados.porCia).length === 0) {
        htmlConteudo = `<div style="text-align:center; padding: 40px; color:#718096; border: 1px dashed #cbd5e0;">Nenhum registro encontrado para os filtros selecionados.</div>`;
    }

    const relatorioFinalHTML = `
        <!DOCTYPE html>
        <html lang="pt-BR">
        <head>
            <meta charset="UTF-8">
            <title>Relatório Operacional - SIAAP</title>
            <style>
                @page { size: A4 portrait; margin: 15mm; }
                body { 
                    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; 
                    margin: 0; padding: 0; color: #1a202c; background-color: #fff;
                    -webkit-print-color-adjust: exact; print-color-adjust: exact;
                }
                
                .cabecalho { display: flex; align-items: center; justify-content: center; border-bottom: 2px solid #2d3748; padding-bottom: 15px; margin-bottom: 20px; }
                .cabecalho img { width: 75px; height: 75px; object-fit: contain; margin-right: 20px; }
                .cabecalho-textos { text-align: center; }
                .cabecalho-textos h1 { font-size: 18px; margin: 0; text-transform: uppercase; letter-spacing: 0.5px; }
                .cabecalho-textos h2 { font-size: 15px; margin: 4px 0; font-weight: normal; color: #4a5568; }
                .cabecalho-textos h3 { font-size: 14px; margin: 4px 0 0 0; font-weight: bold; color: #2b6cb0; }
                
                .info-meta { display: flex; justify-content: space-between; font-size: 11px; color: #4a5568; margin-bottom: 20px; padding: 8px 0; border-bottom: 1px solid #e2e8f0; }
                
                .resumo-kpis { display: flex; justify-content: space-between; gap: 10px; margin-bottom: 30px; }
                .caixa-kpi { flex: 1; border: 1px solid #cbd5e0; padding: 10px; border-radius: 6px; text-align: center; background-color: #f8fafc; }
                .caixa-kpi .titulo { font-size: 10px; font-weight: bold; text-transform: uppercase; color: #718096; margin-bottom: 5px; }
                .caixa-kpi .valor { font-size: 22px; font-weight: bold; color: #2d3748; }
                
                .cia-header { font-size: 16px; font-weight: bold; background-color: #e2e8f0; color: #2d3748; padding: 8px 12px; margin-top: 25px; margin-bottom: 15px; border-left: 4px solid #4a5568; }
                .pel-header { display: flex; justify-content: space-between; align-items: center; font-size: 13px; font-weight: bold; color: #2d3748; margin-top: 15px; margin-bottom: 5px; padding-bottom: 3px; border-bottom: 1px solid #cbd5e0; page-break-after: avoid; }
                .pel-stats { font-size: 11px; font-weight: normal; color: #4a5568; }
                .lideranca-box { font-size: 11px; color: #4a5568; display: flex; gap: 15px; margin-bottom: 10px; }
                
                table { width: 100%; border-collapse: collapse; font-size: 11px; margin-bottom: 20px; page-break-inside: avoid; }
                th { background-color: #f7fafc; color: #4a5568; text-transform: uppercase; font-size: 10px; padding: 8px 6px; text-align: left; border-top: 1px solid #e2e8f0; border-bottom: 2px solid #cbd5e0; }
                td { padding: 8px 6px; border-bottom: 1px solid #edf2f7; vertical-align: top; color: #2d3748; }
                tr:nth-child(even) { background-color: #fafbfc; }
                .endereco { color: #718096; font-size: 9px; display: block; margin-top: 3px; }
                .fora-aula { color: #c53030; font-weight: bold; font-size: 9px; }
                .sem-alteracao { font-size: 11px; color: #38a169; margin-bottom: 20px; font-style: italic; }
                
                .area-assinaturas { display: flex; justify-content: space-around; margin-top: 60px; page-break-inside: avoid; text-align: center; font-size: 12px; color: #2d3748; }
                .linha-assinatura { border-top: 1px solid #2d3748; width: 250px; margin: 0 auto 5px auto; padding-top: 5px; }
                .data-geracao { text-align: right; font-size: 9px; color: #a0aec0; margin-top: 30px; }
            </style>
        </head>
        <body>
            <div class="cabecalho">
                <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão APMBB" />
                <div class="cabecalho-textos">
                    <h1>Polícia Militar do Estado de São Paulo</h1>
                    <h2>Academia de Polícia Militar do Barro Branco</h2>
                    <h3>SIAAP - Relatório Operacional do Efetivo</h3>
                </div>
            </div>

            <div class="info-meta">
                <span><b>Data de Referência:</b> ${formatDateBR(dataReferencia)}</span>
                <span><b>Filtros Aplicados:</b> Cia: ${filtroCia} | Tipo: ${filtroTipo} | Motivo: ${filtroDestinoExato}</span>
            </div>

            <div class="resumo-kpis">
                <div class="caixa-kpi"><div class="titulo" style="color: #e53e3e;">Novidades (Ausentes)</div><div class="valor">${dadosConsolidados.totalFora}</div></div>
                <div class="caixa-kpi"><div class="titulo" style="color: #805ad5;">Fora de Aula</div><div class="valor">${dadosConsolidados.totalForaAula}</div></div>
                <div class="caixa-kpi"><div class="titulo" style="color: #38a169;">Pronto (Em Forma)</div><div class="valor">${dadosConsolidados.totalEmForma}</div></div>
                <div class="caixa-kpi"><div class="titulo" style="color: #3182ce;">Efetivo Total</div><div class="valor">${dadosConsolidados.totalEfetivo}</div></div>
            </div>

            <div class="conteudo-dados">
                ${htmlConteudo}
            </div>

            <div class="area-assinaturas">
                <div>
                    <div class="linha-assinatura"></div>
                    <div>Assinatura do Elaborador</div>
                </div>
                <div>
                    <div class="linha-assinatura"></div>
                    <div>Oficial de Dia / CPU - Ciente</div>
                </div>
            </div>

            <div class="data-geracao">
                Gerado pelo sistema SIAAP em ${new Date().toLocaleString('pt-BR')}
            </div>
        </body>
        </html>
    `;

    const janelaImpressao = window.open('', '', 'width=900,height=800');
    janelaImpressao.document.open();
    janelaImpressao.document.write(relatorioFinalHTML);
    janelaImpressao.document.close();
    janelaImpressao.focus();
    
    setTimeout(() => {
        janelaImpressao.print();
        setIsGenerating(false);
    }, 700);
  };

  if (loading) return <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'80vh', flexDirection:'column', color: COLORS.primary}}><div style={{fontWeight:'bold', fontSize:'18px'}}>Carregando...</div></div>;

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      <style>{interactiveStyles}</style>

      <div className="main-content">
          {usuariosProblematicos.length > 0 && (
              <div style={{ backgroundColor: '#fff5f5', border: '1px solid #e53e3e', padding: '16px', borderRadius: '8px', marginBottom: '16px' }}>
                  <h2 style={{ color: '#c53030', margin: '0 0 8px 0', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}><AlertIcon /> AÇÃO NECESSÁRIA NO BANCO DE DADOS</h2>
                  <p style={{ color: '#742a2a', fontSize: '13px', margin: '0 0 12px 0' }}>Exclua estes usuários da coleção \`users\` no Firebase pois eles não possuem Cia vinculada corretamente.</p>
                  <div style={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: '6px', border: '1px solid #fed7d7' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '12px' }}>
                          <thead style={{ backgroundColor: '#fed7d7', color: '#9b2c2c' }}><tr><th style={{ padding: '8px' }}>Nome</th><th style={{ padding: '8px' }}>CPF/Doc</th><th style={{ padding: '8px' }}>Pelotão Defeituoso</th><th style={{ padding: '8px' }}>ID DO BANCO</th></tr></thead>
                          <tbody>{usuariosProblematicos.map((u, i) => (<tr key={i} style={{ borderBottom: '1px solid #fee2e2' }}><td style={{ padding: '8px', fontWeight: 'bold' }}>{u.nome}</td><td style={{ padding: '8px' }}>{u.cpf}</td><td style={{ padding: '8px', color: '#e53e3e' }}>{u.pelotao}</td><td style={{ padding: '8px' }}><code style={{ backgroundColor: '#f7fafc', padding: '2px 6px', borderRadius: '4px', color: '#2b6cb0', userSelect: 'all' }}>{u.id}</code></td></tr>))}</tbody>
                      </table>
                  </div>
              </div>
          )}
          
          <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão APMBB" style={{ height: '48px', width: '48px', objectFit: 'contain' }} />
                  <div>
                      <h1 style={{ margin: 0, color: '#1a202c', fontSize: '22px', fontWeight: '800', lineHeight: 1.2 }}>Dashboard Operacional</h1>
                      <p style={{ margin: '4px 0 0', color: '#718096', fontSize: '12px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                          <span>Visão consolidada por Companhia e Pelotão</span>
                          {ultimaAtualizacao && (
                              <span style={{ display: 'flex', alignItems: 'center', gap: '4px', backgroundColor: '#edf2f7', padding: '2px 8px', borderRadius: '12px', color: '#4a5568', fontWeight: '600', fontSize: '10px' }}>
                                  <ClockIcon /> Atualizado às {ultimaAtualizacao.toLocaleTimeString('pt-BR')}
                              </span>
                          )}
                      </p>
                  </div>
              </div>

              <div className="desktop-filters">
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', background: 'white', padding: '6px 12px', borderRadius: '8px', border: '1px solid #e2e8f0' }}><span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a0aec0' }}>DATA:</span><input type="date" value={dataReferencia} onChange={(e) => setDataReferencia(e.target.value)} style={{ border: 'none', fontWeight: 'bold', color: COLORS.primary, fontSize: '13px', outline: 'none', cursor:'pointer' }}/></div>
                <div style={{ position: 'relative', minWidth: '180px' }}><select value={filtroCia} onChange={(e) => setFiltroCia(e.target.value)} style={{ width: '100%', padding: '8px 30px 8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', appearance: 'none', backgroundColor: 'white', fontWeight: '600', fontSize: '12px', color: '#4a5568', cursor: 'pointer' }}>{listaCias.map(c => <option key={c} value={c}>{c === 'TODAS' ? 'Todas as Cias' : c}</option>)}</select><div style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none', color: '#a0aec0' }}><FilterIcon /></div></div>
                <div style={{ position: 'relative', minWidth: '180px' }}><select value={filtroDestinoExato} onChange={(e) => setFiltroDestinoExato(e.target.value)} style={{ width: '100%', padding: '8px 30px 8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', appearance: 'none', backgroundColor: 'white', fontWeight: '600', fontSize: '12px', color: '#4a5568', cursor: 'pointer' }}>{destinosDisponiveis.map(d => <option key={d} value={d}>{d === 'TODOS' ? 'Todos os Motivos' : d}</option>)}</select><div style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none', color: '#a0aec0' }}><MapPinIcon /></div></div>
                <div style={{ display: 'flex', background: 'white', borderRadius: '8px', padding: '3px', border: '1px solid #e2e8f0' }}>{['TODOS', 'SIMPLES', 'DETALHADO'].map(tipo => (<button key={tipo} onClick={() => setFiltroTipo(tipo)} className={`filter-btn ${filtroTipo === tipo ? 'active' : ''}`} style={{ padding: '4px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '11px', backgroundColor: filtroTipo === tipo ? COLORS.primary : 'transparent', color: filtroTipo === tipo ? 'white' : '#718096' }}>{tipo}</button>))}</div>
                
                <button onClick={handleGerarRelatorioProfissional} disabled={isGenerating} style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: isGenerating ? '#718096' : '#2b6cb0', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', fontWeight: 'bold', fontSize: '12px', cursor: isGenerating ? 'not-allowed' : 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', transition: 'all 0.2s' }}>
                    <ReportIcon />
                    {isGenerating ? 'Gerando...' : 'Gerar Relatório'}
                </button>
              </div>
          </header>

          <div className="mobile-bottom-nav">
              <label className={`mobile-nav-item ${dataReferencia !== getTodayDate() ? 'active' : ''}`}><CalendarNavIcon /><span>{dataReferencia === getTodayDate() ? 'Data' : formatDateBR(dataReferencia).substring(0,5)}</span><input type="date" value={dataReferencia} onChange={(e) => setDataReferencia(e.target.value)} className="mobile-nav-input"/></label>
              <label className={`mobile-nav-item ${filtroCia !== 'TODAS' ? 'active' : ''}`}><BuildingNavIcon /><span>{filtroCia === 'TODAS' ? 'Cias' : (filtroCia.length > 8 ? filtroCia.substring(0,6)+'..' : filtroCia)}</span><select value={filtroCia} onChange={(e) => setFiltroCia(e.target.value)} className="mobile-nav-input">{listaCias.map(c => <option key={c} value={c}>{c === 'TODAS' ? 'Todas as Cias' : c}</option>)}</select></label>
              <label className={`mobile-nav-item ${filtroDestinoExato !== 'TODOS' ? 'active' : ''}`}><TagNavIcon /><span>{filtroDestinoExato === 'TODOS' ? 'Motivos' : (filtroDestinoExato.length > 8 ? filtroDestinoExato.substring(0,6)+'..' : filtroDestinoExato)}</span><select value={filtroDestinoExato} onChange={(e) => setFiltroDestinoExato(e.target.value)} className="mobile-nav-input">{destinosDisponiveis.map(d => <option key={d} value={d}>{d === 'TODOS' ? 'Todos os Motivos' : d}</option>)}</select></label>
              <label className={`mobile-nav-item ${filtroTipo !== 'TODOS' ? 'active' : ''}`}><LayersNavIcon /><span>{filtroTipo === 'TODOS' ? 'Tipos' : filtroTipo}</span><select value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)} className="mobile-nav-input"><option value="TODOS">Todos</option><option value="SIMPLES">Simples</option><option value="DETALHADO">Detalhado</option></select></label>
          </div>

          <div className="kpi-grid">
            <KPICard title="NOVIDADES" value={dadosConsolidados?.totalFora || 0} color={COLORS.danger} icon={<AlertIcon />} />
            <KPICard title="FORA DE AULA" value={dadosConsolidados?.totalForaAula || 0} color={COLORS.purple} icon={<SchoolIcon />} />
            <KPICard title="PRONTO" value={dadosConsolidados?.totalEmForma || 0} color={COLORS.success} icon={<CheckCircleIcon />} />
            <KPICard title="EFETIVO TOTAL" value={dadosConsolidados?.totalEfetivo || 0} color={COLORS.primary} icon={<UsersIcon />} />
          </div>

          <div className="charts-grid">
            <div className="interactive-card chart-card" style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#2d3748', fontWeight: '700' }}>Por Companhia</h3>
                <div style={{ height: '250px', width: '100%' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={dadosConsolidados?.graficoCia || []} margin={{ top: 20, right: 20, left: -20, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#edf2f7" />
                            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={false} interval={0} />
                            <YAxis axisLine={false} tickLine={false} tick={{fill: '#a0aec0', fontSize: 10}} />
                            <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} cursor={{ fill: '#f7fafc' }} />
                            <Bar dataKey="value" radius={[4, 4, 0, 0]} barSize={isMobile ? 32 : 28}>
                                {dadosConsolidados?.graficoCia.map((entry, index) => <Cell key={`cell-${index}`} fill={getCorCompanhia(entry.name)} />)}
                                <LabelList dataKey="value" position="top" fill="#4a5568" fontSize={11} fontWeight="bold" />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <div style={{ paddingTop: '16px', borderTop: '1px dashed #edf2f7', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '12px' }}>
                    {dadosConsolidados?.graficoCia.map((entry, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#4a5568', fontWeight: '600' }}>
                            <div style={{ width: '12px', height: '12px', borderRadius: '3px', backgroundColor: getCorCompanhia(entry.name) }}></div>
                            {entry.name}
                        </div>
                    ))}
                </div>
            </div>

            <div className="interactive-card chart-card" style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#2d3748', fontWeight: '700' }}>Motivos</h3>
                <div style={{ height: '250px', width: '100%' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                            <Pie data={dadosConsolidados?.graficoDestino || []} cx="50%" cy="50%" innerRadius={55} outerRadius={75} paddingAngle={3} dataKey="value" label={{ fill: '#4a5568', fontSize: 10, fontWeight: '700' }}>
                                {dadosConsolidados?.graficoDestino.map((entry, index) => <Cell key={`cell-${index}`} fill={PIE_COLORS[index % PIE_COLORS.length]} />)}
                                <Label value={dadosConsolidados?.totalFora || 0} position="center" fill="#2d3748" style={{ fontSize: '32px', fontWeight: '900' }} />
                            </Pie>
                            <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', fontSize: '12px', fontWeight: '600' }} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <div style={{ paddingTop: '16px', borderTop: '1px dashed #edf2f7' }}>
                    <ul className="custom-legend-grid">
                        {dadosConsolidados?.graficoDestino.map((entry, index) => (
                        <li key={`leg-mot-${index}`} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ width: '10px', height: '10px', backgroundColor: PIE_COLORS[index % PIE_COLORS.length], borderRadius: '3px', flexShrink: 0 }}></span>
                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={entry.name}>
                                {entry.name}
                            </span>
                        </li>
                        ))}
                    </ul>
                </div>
            </div>

            {dadosConsolidados?.graficoGremioEquipe && dadosConsolidados.graficoGremioEquipe.length > 0 && (
                <div className="interactive-card chart-card" style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#805ad5', fontWeight: '700' }}>Grêmios / Equipes</h3>
                    <div style={{ height: '250px', width: '100%' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                                <Pie data={dadosConsolidados.graficoGremioEquipe} cx="50%" cy="50%" innerRadius={55} outerRadius={75} paddingAngle={3} dataKey="value" label={{ fill: '#4a5568', fontSize: 10, fontWeight: '700' }}>
                                    {dadosConsolidados.graficoGremioEquipe.map((entry, index) => <Cell key={`cell-gremio-${index}`} fill={PIE_COLORS[(index + 2) % PIE_COLORS.length]} />)}
                                    <Label value={dadosConsolidados.graficoGremioEquipe.reduce((a,c)=>a+c.value,0)} position="center" fill="#2d3748" style={{ fontSize: '32px', fontWeight: '900' }} />
                                </Pie>
                                <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', fontSize: '12px', fontWeight: '600' }} />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <div style={{ paddingTop: '16px', borderTop: '1px dashed #edf2f7' }}>
                        <ul className="custom-legend-grid">
                            {dadosConsolidados.graficoGremioEquipe.map((entry, index) => (
                            <li key={`leg-grem-${index}`} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span style={{ width: '10px', height: '10px', backgroundColor: PIE_COLORS[(index + 2) % PIE_COLORS.length], borderRadius: '3px', flexShrink: 0 }}></span>
                                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={entry.name}>
                                    {entry.name}
                                </span>
                            </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
          </div>

          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <div className="resumo-card">
                <h3 style={{ margin: '0 0 16px 0', fontSize: '13px', color: '#4a5568', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>RESUMO POR COMPANHIA</h3>
                {dadosConsolidados && Object.keys(dadosConsolidados.resumoCiaDestino).sort((a,b) => a.localeCompare(b)).map(ciaName => (
                    <div key={ciaName} style={{ marginBottom: '16px' }}>
                        <div style={{ fontWeight: '800', fontSize: '14px', color: '#2d3748', marginBottom: '8px' }}>{ciaName}</div>
                        {Object.entries(dadosConsolidados.resumoCiaDestino[ciaName]).sort((a,b) => a[0].localeCompare(b[0])).map(([destino, count]) => (
                            <div key={destino} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#4a5568', marginBottom: '4px', borderBottom: '1px solid #edf2f7', paddingBottom: '4px' }}><span>{destino}</span><span style={{ fontWeight: '700', color: '#2d3748' }}>{count}</span></div>
                        ))}
                    </div>
                ))}
            </div>

            <div style={{ flex: '1 1 75%', minWidth: '300px' }}>
                <h3 style={{ margin: '0 0 16px 0', fontSize: '13px', color: '#4a5568', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>MILITARES AFASTADOS (DETALHES)</h3>
                {dadosConsolidados && Object.values(dadosConsolidados.porCia).sort((a,b) => a.nome.localeCompare(b.nome)).map(cia => (
                    <div key={cia.nome} style={{ marginBottom: '20px' }}>
                        <div style={{ borderBottom: '2px solid #e2e8f0', paddingBottom: '6px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontWeight: '800', fontSize: '15px', color: '#2d3748' }}>{cia.nome}</span>
                            <BotaoCopiarCia cia={cia} configDestinos={configDestinos} dataReferencia={dataReferencia} />
                        </div>
                        {Object.values(cia.pelotoes).sort((a,b) => a.nome.localeCompare(b.nome, 'pt-BR', { numeric: true })).map(pel => (
                            <AccordionPelotao key={pel.nome} pel={pel} configDestinos={configDestinos} usersMap={usersMap} dataReferencia={dataReferencia} />
                        ))}
                    </div>
                ))}
                {dadosConsolidados && Object.keys(dadosConsolidados.porCia).length === 0 && (
                    <div style={{ textAlign: 'center', padding: '30px', color: '#a0aec0', border: '1px dashed #cbd5e0', borderRadius: '10px' }}><p style={{margin: 0, fontWeight: '500'}}>Nenhum registro encontrado para os filtros selecionados.</p></div>
                )}
            </div>
          </div>
      </div>
    </div>
  );
};

const KPICard = ({ title, value, color, icon }) => (
    <div className="interactive-card" style={{ backgroundColor: 'white', padding: '12px', borderRadius: '10px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderTop: `4px solid ${color}`, minHeight: '75px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><div style={{ color: color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{React.cloneElement(icon, { width: 18, height: 18 })}</div><div style={{ fontSize: '10px', color: '#718096', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0 }}>{title}</div></div>
        <div style={{ fontSize: '26px', fontWeight: '800', color: '#2d3748', lineHeight: 1, paddingLeft: '24px', marginTop: '4px' }}>{value}</div>
    </div>
);

export default NewDashboard;